/* eslint-disable react/prop-types */
import React from 'react';
import _ from 'lodash';
import { Formik, Form } from 'formik';

import { CONSTANT } from '../utils/constant';
import RegistrationModal from './modal';

import {
  FirstName,
  LastName,
  Email,
  Password,
  Province,
  Contact,
  Role,
  Channel,
  MultiChannel,
  Outlet,
  Cpms,
  Dealership,
  SalesManager,
  SalesManagerEmail,
  Captcha,
  Button,
  MultiProvince,
  ChannelOrgCode,
  Xid,
  StoreCode,
  OrderAccess
} from './fields';

const {
  KEYS: {
    CHANNELS: { DEALER, BCX_CARE, ADT, HEALTH, CSD, NBD, CORP_STORE },
    ROLES: {
      SALES_SUPPORT,
      SALES_MANAGER,
      SALES_REP,
      MANAGER_TIME_TRACKING,
      TEAM_MEMBER_TIME_TRACKING
    }
  }
} = CONSTANT;

const RegistrationForm = ({
  labels,
  schema,
  onSubmit,
  initialValues,
  loading,
  onChange,
  showModal,
  confirmationDialog,
  isRedirectedFromPassport
}) => {
  const getFields = (role, value) => {
    const valueChannel =
      role === SALES_SUPPORT
        ? _.get(value, 'multiChannels', [])
        : _.get(value, 'channel.0.id', '');

    if ([MANAGER_TIME_TRACKING, TEAM_MEMBER_TIME_TRACKING].includes(role)) {
      return [Province, Xid];
    }

    if (valueChannel === DEALER && role !== SALES_MANAGER)
      return [
        Province,
        Channel,
        Dealership,
        ChannelOrgCode,
        Cpms,
        Outlet,
        SalesManager,
        SalesManagerEmail
      ];

    if (valueChannel === CORP_STORE)
      return [
        Province,
        Channel,
        StoreCode,
        role === SALES_MANAGER ? ChannelOrgCode : Cpms,
        Outlet,
        Xid,
        SalesManager,
        SalesManagerEmail
      ];

    if (
      [SALES_MANAGER, SALES_REP].includes(role) &&
      [BCX_CARE, ADT, HEALTH, CSD, NBD].includes(valueChannel)
    )
      return [Province, Channel, Xid, SalesManager, SalesManagerEmail];

    if (role === SALES_SUPPORT) {
      if (valueChannel.includes(DEALER) && !valueChannel.includes(CORP_STORE))
        return [
          MultiProvince,
          MultiChannel,
          Xid,
          SalesManager,
          SalesManagerEmail
        ];
      if (valueChannel.includes(CORP_STORE) && !valueChannel.includes(DEALER))
        return [
          MultiProvince,
          MultiChannel,
          StoreCode,
          Xid,
          SalesManager,
          SalesManagerEmail
        ];
      if (valueChannel.includes(CORP_STORE) && valueChannel.includes(DEALER))
        return [
          MultiProvince,
          MultiChannel,
          StoreCode,
          Xid,
          SalesManager,
          SalesManagerEmail
        ];
      return [
        MultiProvince,
        MultiChannel,
        Xid,
        SalesManager,
        SalesManagerEmail
      ];
    }
    if (role === SALES_MANAGER){
      if (valueChannel.includes(DEALER))
        return [
          Province,
          Channel,
          Dealership,
          ChannelOrgCode,
          OrderAccess,
          ...(_.get(value, 'requiresOrderAccess') === 'yes' ? [Cpms] : []),
          Outlet,
          SalesManager,
          SalesManagerEmail
        ];
      return [
        Province,
        Channel,
        ChannelOrgCode,
        Outlet,
        SalesManager,
        SalesManagerEmail
      ];
    }

    return [Province, Channel, Cpms, Outlet, SalesManager, SalesManagerEmail];
  };

  return (
    <>
      {showModal && <RegistrationModal show labels={confirmationDialog} />}
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={(values, actions) => {
          onSubmit(values, actions);
        }}
      >
        {({ errors, touched, setFieldValue, values, handleSubmit }) => (
          <Form>
            <Role
              labels={labels}
              errors={errors}
              touched={touched}
              values={values}
            />
            <FirstName
              labels={labels}
              errors={errors}
              touched={touched}
              disabled={isRedirectedFromPassport}
            />
            <LastName
              labels={labels}
              errors={errors}
              touched={touched}
              disabled={isRedirectedFromPassport}
            />
            <Email
              labels={labels}
              errors={errors}
              touched={touched}
              disabled={isRedirectedFromPassport}
            />
            <Password labels={labels} errors={errors} touched={touched} />
            <Contact labels={labels} errors={errors} touched={touched} />

            {values.role && (
              <>
                {getFields(values.role, values).map(Component => (
                  <Component
                    labels={labels}
                    errors={errors}
                    touched={touched}
                    role={values.role}
                    values={values}
                    setFieldValue={setFieldValue}
                  />
                ))}
              </>
            )}

            <Captcha
              onChange={value => {
                onChange(value);
                setFieldValue('recaptcha', value || '');
              }}
              errors={errors}
              touched={touched}
              value={values.recaptcha}
            />
            <Button loading={loading} confirmationDialog={confirmationDialog} formik={{ handleSubmit }} />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default RegistrationForm;
